import script from "./RoleSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSettings.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSettings.vue?vue&type=style&index=0&id=72d2c5d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d2c5d0"]])

export default __exports__